import React, { useState, useContext } from 'react';
import styles from './RemoveFriendModal.module.sass';
import Modal from '../../../components/Modal';
import TextInput from '../../../components/TextInput';
import Loader from '../../../components/LoaderCircle';
import { ConquerContext } from '../../../contexts/ConquerContext';

const RemoveFriendModal = ({ onFriendRemoved, friend }) => {

    const conquer = useContext( ConquerContext );

    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    function showError(message) {
        setError(message);
        return false;
    }

    async function tryToRemoveFriend() {

        setIsLoading(true);
        let response = await conquer.Friends.remove(friend.avatarID);
        console.log( response );
        setIsLoading(false);

        if ( response.error ) return showError(response.error);

        onFriendRemoved?.();

    }

    return (
        <>
            <button
                className={'button small'}
                onClick={() => {
                    setIsVisible(true);
                }}>
                Remove
            </button>
            {isVisible && (
                <Modal
                    visible={true}
                    onClose={() => {
                        setIsVisible(false);
                    }}
                    title='Remove Friend'>
                    <div className={styles.container}>
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <p>Are you sure you want to remove {friend.firstName} from your friends? </p>
                                <button
                                    className='button'
                                    onClick={tryToRemoveFriend}>
                                    Remove Friend
                                </button>
                                {error && (
                                    <p
                                        style={{
                                            color: 'red',
                                            maxWidth: '75%',
                                            textAlign: 'center',
                                        }}>
                                        {error}
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </Modal>
            )}
        </>
    );
};

export default RemoveFriendModal;
